/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const Paths = {
  SAMPLE_APPLICATION: {
    ROOT: '/sample-application',
    OVERVIEW: '/sample-application/overview',
    FORM: '/sample-application/form',
    CONFIRMATION: '/sample-application/confirmation',
  },

  /* BEGIN - SD-1064 - YP - Adding new Profile page which can be accessed from 'Your account' page */
  PROFILE: '/profile',
  /* END - SD-1064 - YP - Adding new Profile page which can be accessed from 'Your account' page */

  /* BEGIN - SD-1067 - RC -  Adding new Survey path */
  SURVEY: '/survey',
  /* END - SD-1067 - RC - Adding new Survey path */

  LOCAL_OFFICE: '/local-office',

  LINK_ACCOUNT: '/link-my-account',
  /* BEGIN - SD-1064 - AK - Adding new Online COC Overview page */
  ONLINECOCOVERVIEW: '/onlineCOCOverview',
  /* END - SD-1064 - AK - Adding new Online COC Overview page */

  /* BEGIN - SD-1064 - AK - Adding new Revewal Application Overview page */
  RENEWALAPPLICAATIONOVERVIEW: '/renewalApplicationOverview',
  /* END - SD-1064 - AK - Adding new Online COC Overview page */

  /* BEGIN - SD-1029 - MS - RIDP component */
  VERIFYYOURIDENTITY: '/verifyyouridentity',
  VERIFYYOURIDENTITYRESULT: '/verifyyouridentityresult',
  FARSRESULT: '/farsresult',
  /* END - SD-1029 - MS - RIDP component */

  /* BEGIN - SD-1043 - Staten: adding a path value to link to the settings page */
  SETTINGS: '/settings',
  /* END - SD-1043 - Staten: adding a path value to link to the settings page */

  SDCCARENEWALAPPLICAATIONOVERVIEW: '/sdccaRenewalApplicationOverview',
  SDCCAPAYMENTS: '/sdccaPayments',
  SDCCAPAYMENTSDETAILS: '/sdccapaymentsDetails',
  /* BEGIN - SDMO-5859 CR-53 - CP - for SNAP-Only changes */
  APPLYFORSNAP: '/applyForSNAP',
  APPLYFORSNAPFORM: '/applyForSNAP/new',
  APPLYFORSNAPFORMRESUME: '/applyForSNAP/form',
  /* END - SDMO-5859 CR-53 - CP - for SNAP-Only changes */
};

/**
 * Provides access the the URLs that are mapped to each page via the route configuration.
 */
export default Paths;
